export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./YoutubeFeed.vue?vue&type=template&id=b15abc46&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/YoutubeFeed.vue?vue&type=template&id=b15abc46&
// module id = 60
// module chunks = 7 9